<section id="about-us" class="section about-section">
  <div class="container">
    <div class="about-grid">
      <div class="about-content">
        @if (aboutPage) {
          <div [innerHTML]="aboutPage.description"></div>
        }
        <div class="stats-container">
          <div class="stat-item">
            <span class="stat-number">1997</span>
            <span class="stat-label">Established</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">2001</span>
            <span class="stat-label">Public Limited</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">10k+</span>
            <span class="stat-label">Happy Clients</span>
          </div>
        </div>
      </div>
      
      <div class="team-section">
        <h3 class="team-title">Our Leadership Team</h3>
        <div class="team-list-container">
          @if (team && team.length === 0) {
            <div class="no-data-fallback" style="grid-column: 1 / -1;">No data found.</div>
          }
          @for (member of team || []; track $index) {
            <div class="corp-card team-card" [ngClass]="'team-card-color-' + ($index % 6)">
              <div class="member-avatar">
                @if (member.image) {
                  <img [src]="member.image" [alt]="member.name" class="member-image">
                } @else {
                  <span class="avatar-initials">{{member.name.charAt(0)}}</span>
                }
              </div>
              <div class="member-info">
                <h4 class="member-name">{{member.name}}</h4>
                <span class="member-role">{{member.designation?.name}}</span>
                <p class="member-desc">{{member.shortBio}}</p>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</section>
